import React from 'react';
import { TrashCanIcon } from '../../../../../../assets/icons';
import styles from './NotificationList.module.scss';
import Button from '../../../../../../common/components/xepp/button/Button';
import Can from '../../../../../../guards/Can';
import { UtilityPermissions } from '../../../../../../model/permissions/permissions';

export interface NotificationListItem {
    id: string | number;
    groupId?: string;
    title: string;
    message?: string;
    createdAt?: string;
}

interface NotificationListProps {
    notifications: NotificationListItem[];
    onDelete: (id: string | number) => void;
}

const NotificationList: React.FC<NotificationListProps> = ({ notifications, onDelete }) => {
    if (notifications.length === 0) {
        return <p className={styles.empty}>No notifications found.</p>;
    }

    return (
        <ul className={styles.list}>
            {notifications.map(item => (
                <li key={item.id} className={styles.item}>
                    <div className={styles.content}>
                        <span className={styles.title}>{item.title}</span>
                        {item.message && <span className={styles.message}>{item.message}</span>}
                    </div>
                    <Can permission={UtilityPermissions.DeleteBroadcastNotification}>
                        <Button
                            onClick={() => onDelete(item.id)}
                            aria-label="Delete notification"
                            rightIcon={<TrashCanIcon />}
                        text=""
                        variant="outline"
                        />
                    </Can>
                </li>
            ))}
        </ul>
    );
};

export default NotificationList;
